import http from './http-service'
import {
  ChatSessionHistory,
  ChatSessionsList,
  CreateSessionRequest,
  CreateSessionResponse,
  SendMessageRequest,
  SendMessageResponse,
  ChatProvider,
  TestProviderRequest,
  TestProviderResponse,
} from 'interfaces/chat.interface'
import {
  CHAT_SESSIONS,
  CHAT_SESSIONS_LIST,
  CHAT_SESSION_HISTORY,
  CHAT_SESSION_DELETE,
  CHAT_MESSAGES,
  CHAT_PROVIDERS,
  CHAT_PROVIDERS_TEST,
} from './endpoint-urls'

// Chat Session Management
export const createChatSession = (data: CreateSessionRequest) => {
  return http
    .post<CreateSessionResponse>(CHAT_SESSIONS, data)
    .then(res => res.data)
}

export const getChatSessions = () => {
  return http.get<ChatSessionsList>(CHAT_SESSIONS_LIST).then(res => res.data)
}

export const getChatHistory = (sessionId: string) => {
  return http
    .get<ChatSessionHistory>(`${CHAT_SESSION_HISTORY}/${sessionId}`)
    .then(res => res.data)
}

export const deleteChatSession = (sessionId: string) => {
  return http
    .delete<{ message: string }>(`${CHAT_SESSION_DELETE}/${sessionId}/delete`)
    .then(res => res.data)
}

// Messaging
export const sendChatMessage = (
  sessionId: string,
  data: SendMessageRequest
) => {
  return http
    .post<SendMessageResponse>(`${CHAT_MESSAGES}/${sessionId}/messages`, data)
    .then(res => res.data)
}

// Provider Management
export const getAvailableProviders = () => {
  return http.get<ChatProvider[]>(CHAT_PROVIDERS).then(res => res.data)
}

export const testProvider = (data: TestProviderRequest) => {
  return http
    .post<TestProviderResponse>(CHAT_PROVIDERS_TEST, data)
    .then(res => res.data)
}
